const zIndices = {
  searchBar: 1071,
  timePicker: 1071,
  headerSubMenuContent: 1072,
};

export type ZIndices = typeof zIndices;

export default zIndices;
